(function () {
  const initializedSliders = new WeakSet();
  let revealObserver;

  function initVideoSlider(sectionEl) {
    if (!sectionEl || initializedSliders.has(sectionEl)) return;

    const viewport = sectionEl.querySelector('[data-f69-viewport]');
    const items = Array.from(viewport ? viewport.children : []).filter(function (item) {
      return item.hasAttribute('data-f69-item');
    });
    if (!viewport || items.length === 0) return;

    initializedSliders.add(sectionEl);

    const prevButton = sectionEl.querySelector('[data-f69-prev]');
    const nextButton = sectionEl.querySelector('[data-f69-next]');
    const cloneCount = Math.min(items.length, 4);
    let allItems = items;
    let resizeTimer;
    let scrollEndTimer;

    function prepareClone(item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-f69-item');
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (focusable) {
        focusable.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    if (items.length > 1) {
      for (let i = 0; i < cloneCount; i += 1) {
        viewport.appendChild(prepareClone(items[i]));
        viewport.insertBefore(prepareClone(items[items.length - 1 - i]), viewport.firstChild);
      }

      allItems = Array.from(viewport.querySelectorAll('.f69-video__item'));
    }

    function centerItem(item, behavior) {
      if (!item) return;

      viewport.scrollTo({
        left: item.offsetLeft - viewport.clientWidth / 2 + item.offsetWidth / 2,
        behavior: behavior || 'auto',
      });
    }

    function syncMediaState(fromItem, toItem) {
      const fromVideo = fromItem ? fromItem.querySelector('video') : null;
      const toVideo = toItem ? toItem.querySelector('video') : null;

      if (!fromVideo || !toVideo) return;

      try {
        if (Number.isFinite(fromVideo.currentTime)) toVideo.currentTime = fromVideo.currentTime;
        toVideo.playbackRate = fromVideo.playbackRate;
      } catch (error) {
        // Some browsers reject currentTime updates before metadata is ready.
      }

      if (!fromVideo.paused) {
        const playPromise = toVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    }

    function getClosestIndex() {
      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      allItems.forEach(function (item, index) {
        const itemRect = item.getBoundingClientRect();
        const itemCenter = itemRect.left + itemRect.width / 2;
        const distance = Math.abs(viewportCenter - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function applyFocus() {
      const activeIndex = getClosestIndex();

      allItems.forEach(function (item, index) {
        const video = item.querySelector('video');
        const isActive = index === activeIndex;

        item.classList.toggle('is-active', isActive);

        if (!video) return;

        if (isActive) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {
              // autoplay may fail when browser blocks it
            });
          }
        } else {
          video.pause();
        }
      });
    }

    function normalizeLoop() {
      if (items.length <= 1) return;

      const activeIndex = getClosestIndex();
      let matchingIndex = activeIndex;

      if (activeIndex < cloneCount) {
        matchingIndex = activeIndex + items.length;
      } else if (activeIndex >= cloneCount + items.length) {
        matchingIndex = activeIndex - items.length;
      }

      if (matchingIndex !== activeIndex) {
        syncMediaState(allItems[activeIndex], allItems[matchingIndex]);
        centerItem(allItems[matchingIndex], 'auto');
      }
    }

    function finishScroll() {
      normalizeLoop();
      applyFocus();
    }

    function handleScroll() {
      applyFocus();
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(finishScroll, 140);
    }

    function moveBy(step) {
      finishScroll();
      centerItem(allItems[getClosestIndex() + step], 'smooth');
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        moveBy(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        moveBy(1);
      });
    }

    allItems.forEach(function (item) {
      item.addEventListener('click', function () {
        centerItem(item, 'smooth');
      });
    });

    viewport.addEventListener('scroll', handleScroll, { passive: true });
    viewport.addEventListener('scrollend', finishScroll);

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        centerItem(allItems[getClosestIndex()], 'auto');
        applyFocus();
      }, 120);
    });

    window.setTimeout(function () {
      centerItem(allItems[items.length > 1 ? cloneCount : 0], 'auto');
      applyFocus();
    }, 60);
  }

  function initReveal(scope) {
    const revealElements = Array.from(scope.querySelectorAll('.f69-reveal'));
    if (revealElements.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      revealElements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px',
        }
      );
    }

    revealElements.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        revealObserver.observe(el);
      }
    });
  }

  function initAll(scope) {
    const root = scope || document;
    const sliders = Array.from(root.querySelectorAll('[data-f69-video-slider]'));
    sliders.forEach(initVideoSlider);
    initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
